import React, { useEffect, useState } from 'react'

// Formik validation
import * as Yup from 'yup';
import Select from 'react-select'
import { useFormik } from 'formik';
import { Button, Form, FormFeedback, Input, Modal } from 'reactstrap';

import { BaseCustomButton, BaseCustomModal, BaseSelectComponent, GradientDecorationLine } from '../../shared';

export const NewNormModal = ({ props, setShowModal, showModal, modalRespInfo, modalHeader, modalClose, isUpdate, rowInfo, norms }) => {
    const [file, setFile] = useState(null);

    const [normData, setNormData] = useState('');
    const [typesRegulation, setTypesRegulation] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (showModal === true) {
            setTypesRegulation((isUpdate) ? rowInfo.normType : '');
            setDescription((isUpdate) ? rowInfo.description : '')
            setFile(null);
        }
        if (isUpdate) {
            setNormData('');
        }

    }, [showModal])

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            norm: isUpdate ? rowInfo.norm : '',
            datedAt: isUpdate ? rowInfo.datedAt : '',
            password: isUpdate ? rowInfo.password : '',
        },
        validationSchema: Yup.object({
            norm: Yup.object().nullable().required("Seleccione una norma"),
            datedAt: Yup.date().required("Seleccione una fecha"),
            password: Yup.string().required("Ingrese una contraseña")
        }),
        onSubmit: (values, { resetForm }) => {
            const { norm, ...rest } = values;
            const respInfo = file ? {
                  ...rest,
                  norm: norm.id,
                  normType: typesRegulation,
                  description: description,
                  file: file,
                } : {
                  ...rest,
                  norm: norm.id,
                  normType: typesRegulation,
                  description: description,
                };
            modalRespInfo(respInfo);
            resetForm();
            setTypesRegulation('');
            setDescription('');
            setNormData('');
            setShowModal(false);
        }
    });

    const handleSelectNorm = (selectedOption) => {
        if (selectedOption) {
          // we get the full norm object from the array of norms
          const fullNorm = norms.find(n => n.id === selectedOption.value);
  
          // we set the value of the select
          validation.setFieldValue('norm', fullNorm);
  
          // we set the values of the other fields
          if (fullNorm?.typesRegulation?.name) {
            setTypesRegulation(fullNorm.typesRegulation.name);
          } else {
            setTypesRegulation('');
          }
  
          if (fullNorm?.description) {
            setDescription(fullNorm.description);
          } else {
            setDescription('');
          }
        } else {
          // Si se limpia el select
          validation.setFieldValue('norm', null);
          setTypesRegulation('');
          setDescription('');
        }
    };

    const { className } = props;

    const toggle = () => {
        setShowModal(false);
        setTypesRegulation('');
        setDescription('');
    }

    const onClosed = () => {
        validation.resetForm();
        modalClose();
        setTypesRegulation('');
        setDescription('');
        setNormData('');
        setShowModal(false);
    }

    const pruebaDatos = (e) => {
        setFile(Object.values(e)[0]);
    }

    useEffect(() => {
        setTypesRegulation((normData?.typesRegulation?.name) ? normData.typesRegulation.name : '');
        setDescription((normData?.description) ? normData.description : '');
    }, [normData])

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color='success'
                className='rounded-3 me-4'
                onClick={validation.handleSubmit}
                label='Guardar'
                outline={true}
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color='danger'
                className='rounded-3 me-3'
                onClick={toggle}
                label='Cancelar'
                outline={true}
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    const title = (    
        <div className='d-flex ms-3 p-0'>
            <label className='m-0 p-0'><h4 className='text-primary m-0 ps-4'>{modalHeader}</h4></label>
        </div>
    );

    const children = (

        <Form
            className="form-horizontal mt-3 mb-1"
            onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
            }}
        >
            <GradientDecorationLine />

            <div className='px-4 mx-3 mb-4'>
                <label htmlFor="exampleInputEmail1" className='text-primary'>Norma</label>
                <BaseSelectComponent
                    placeholder="Seleccione Norma..."
                    name="norm"
                    // we map the norms to get the value and label
                    options={norms.map(norm => ({ value: norm.id, label: norm.name }))} 
                    onChangeAsObject={true}
                    // onChange: we get the selected option and pass it to the handleSelectNorm function
                    onChange={handleSelectNorm}
                    // we set the field as touched when the user selects an option
                    onBlur={() => validation.setTouched({ ...validation.touched, norm: true })}
                    // we set the value of the select
                    value={
                    validation.values.norm
                        ? { 
                            value: validation.values.norm.id, 
                            label: validation.values.norm.name 
                        }
                        : null
                    }
                    touched={validation.touched.norm}
                    error={validation.errors.norm}
                    status={validation.errors.norm &&  validation.touched.norm ? 'error' : ''}
                />
            </div>

            <div className='px-4 mx-3 mb-4'>
                <label className='text-primary'>Tipo de Normativa</label>
                <Input
                    disabled={true}
                    name="normType"
                    className="form-control text-primary text-center rounded-3 w-100"
                    placeholder="Tipo de Normativa"
                    type="text"
                    value={typesRegulation}
                />
            </div>

            <div className='px-4 mx-3 mb-4'>
                <label className='text-primary'>Descripción de la norma</label>
                <textarea
                    name="description"
                    disabled={true}
                    className="form-control text-primary text-center rounded-3 w-100"
                    placeholder="Descripción de la norma"
                    type="text"
                    value={description}
                />
            </div>

            <div className='px-4 mx-3 mb-4'>
                <label className='text-primary'>Vigencia</label>
                <Input
                    name="datedAt"
                    required
                    className="form-control text-primary text-center rounded-3 w-100"
                    type="date"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.datedAt || ""}
                    invalid={
                        !!(validation.touched.datedAt && validation.errors.datedAt)
                    }
                />
                {validation.touched.datedAt && validation.errors.datedAt ? (
                    <FormFeedback type="invalid">{validation.errors.datedAt}</FormFeedback>
                ) : null}
            </div>

            <div className='px-4 mx-3 mb-4'>
                {
                    isUpdate
                        ? <label className='text-primary'>Reemplazar archivo</label>
                        : <label className='text-primary'>Cargar archivo</label>
                }
                <Input
                    name="file"
                    required={!isUpdate}
                    type="file"
                    className='rounded-3'
                    onChange={(e) => pruebaDatos(e.target.files)}
                />
            </div>

            <div className='px-4 mx-3 mb-4'>
                <label className='text-primary'>Contraseña</label>
                <Input
                    name="password"
                    required
                    className="form-control text-primary text-center rounded-3 w-100"
                    placeholder="Contraseña"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.password || ''}
                    invalid={
                        !!(validation.touched.password && validation.errors.password)
                    }
                />
                {validation.touched.password && validation.errors.password ? (
                    <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                ) : null}
            </div>

            <GradientDecorationLine />

        </Form>

    );

    return (
        <>
            <BaseCustomModal
                title={title}
                isModalOpen={showModal}
                handleOk={validation.handleSubmit}
                handleCancel={toggle}
                className={className}
                children={children}
                onClosed={onClosed}
                centered
                width="60%"
                style={{ overflowY: 'auto' }}
                footer={buttons}
            />
        </>
    )
}
